/*
 * The statement read, kept beside the page (not in ../api.js) so this branch stays additive; same
 * group, JWT and payment grant as the Overview routes. Fold into ../api.js when convenient.
 */
import { get_api } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';
import { envelope_data } from '../format';

export const statement_url = (month) =>
  get_api_url(
    `/v2/cms_user/teacher_payments/overview/statement?month=${encodeURIComponent(month)}`
  );

export const fetch_statement = (month) => get_api(statement_url(month), true).then(envelope_data);

export { fetch_months } from '../api';
